module.exports = __webpack_public_path__ + "img/Slider_montagne-EJ.d3fa2784.png";